<template>
    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-6">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} {{$t('of')}} {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10" v-if="!showTestIntro && test">

                <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

                    <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
                         v-if="currentTask.testtask"
                         @click="play(mainElement.audio)">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{$t('№')}}{{currentTask.pos}}.</span>{{ currentTask.testtask }}
                    </div>

                    <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
                         v-if="test.description && test.description !== currentTask.testtask">{{
                        test.description }}
                    </div>

                    <div class="test-answers col-12 text-center mb-5">
                        <button
                                class="btn btn-secondary btn-large mt-4 test-question-btn"
                                @click="setCurrentElement(currentElement)">
                            {{ currentElement?currentElement.word:'' }}
                            <i class="fa fa-volume-up ml-3"></i>
                        </button>
                    </div>

                    <div class="col-xl-4 offset-xl-3 col-12 mt-xl-0 mt-2 text-center" v-if="mainElement.image">
                        <img :src="imageSrc"
                            ref="image-area"
                            class="test-image single-image"
                            @click="imageClick"
                        >
                    </div>

                    <div class="col-xl-5 col-12 mb-xl-0 mb-5">
                        <div class="row justify-content-xl-start justify-content-center">
                            <div v-for="(item, i) in answers"
                                 :key="i"
                                 class="test-answers col-auto col-xl-12"
                            >
                                <div
                                    @click="colorClick(item)"
                                    :class="['my-1', item.cls]"
                                    :style="'width: 50px; height: 50px; background-color: '+ item.word2"
                                >
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>


        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
            <button
                    class="btn btn-info"
                    @click="skip"
            >
                {{ $t('omit_task') }} &rarr;
            </button>
        </div>
    </div>

</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<script>
    import Vue from 'vue'
    import api from '@/utils/api'

    export default {
        name: 'Test16',
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
            testmode: {default: 0},
        },

        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            taskIdx: 0,
            imageSrc: null,
            currentElement: null,
            currentColor: null,
            errorCount: 0,

            audio: new Audio(),
            forceRenderKey: 0,

            //errorChord: 'gong.mp3',
            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',

            showTestIntro: true,
        }),

        computed: {
            currentTask: function () {
                // console.log('currentTask')
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },

            mainElement: function () {
                // console.log('mainElement', this.getBy('ismain', 1, this.testelements))
                return this.getBy('ismain', 1, this.testelements)
            },

            answers: function () {
                // console.log('answers')
                return this.testelements.filter(function (e) {
                    return !e.ismain
                })
            },
        },

        watch: {
            taskIdx: async function () {
                this.loadTask()
            },
        },

        async mounted() {
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            this.loading = false
        },

        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                if (this.currentTask.idtesttask) {
                    const response = await api({
                        method: 'get',
                        url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
                    })
                    this.testelements = response.data
                    await this.play(this.mainElement.audio)
                    this.imageSrc = this.mainElement.image
                    this.setCurrentElement(this.answers[0])
                } else {
                    this.$emit('testComplete')
                }
            },
            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            // console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },

            setCurrentElement (item) {
                this.play(item.audio)
                this.currentElement = item
            },

            colorClick (item) {
                this.setSelected(item)
                this.currentColor = item
            },

            async imageClick (e) {
                if(!this.currentElement || !this.currentColor) return

                const pos = this.calcPosOfImage()
                const x = ((e.pageX - pos.left)*100)/pos.width
                const y = ((e.pageY - pos.top)*100)/pos.height
                const item = this.getObject(x, y)
                if(item && item.idtestelement == this.currentElement.idtestelement && item.idtestelement == this.currentColor.idtestelement) {
                    Vue.set(item, 'type', 'correct')
                    this.imageSrc = item.image // change picture
                    // if (item.audio) await this.play(item.audio) else
                    await this.play(this.okChord)
                    this.currentElement = this.next()
                } else {
                    await this.play(this.errorChord)
                    this.errorCount++
                }
            },

            getObject (x, y) {
                for (const i in this.answers) {
                    if(!this.answers[i].data) continue
                    let rects = this.answers[i].data
                    if(!Array.isArray(rects)) rects = [ rects ]

                    for (const r in rects) {
                        if (rects[r].w && x>rects[r].x && x<rects[r].x+rects[r].w && y>rects[r].y && y<rects[r].y+rects[r].h) {
                            return this.answers[i]
                        }
                    }
                }

                return null
            },

            setSelected (item) {
                if(item.cls != 'border-solid4' ) Vue.set(item, 'cls', 'border-solid4')

                for (const i in this.answers) {
                    if (item.idtestelement != this.answers[i].idtestelement) {
                        Vue.set(this.answers[i], 'cls', null)
                    }
                }

                return null
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },

            next: function (item) {
                for (const i in this.answers) {
                    if(this.answers[i].type != 'correct') {
                        this.setCurrentElement(this.answers[i])
                        return this.answers[i]
                    }
                }

                if (this.testmode == 0 || !this.errorCount) this.$emit('correctAnswer')
                else this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: `Неправильных попыток раскрашиваний: ${this.errorCount}.`})
                this.taskIdx++
            },

            calcPosOfImage () {
                let ref = this.$refs['image-area']
                const rect = ref.getBoundingClientRect()
                const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop
                const top = rect.top + scrollTop

                const left = rect.left + scrollLeft

                return {left: left, top: top, width: rect.width, height: rect.height}
            },
        },
    }
</script>
